import React from "react";
import { Images } from "../Common/Images.jsx";
import { useTranslation } from 'react-i18next';

export default function ErrorPopupModal({ title, message, onClose }) {
const { t } = useTranslation("common");

  return (
    <div className="modal errorpopup errorpopup-backdrop" id="errorModal" data-bs-backdrop="static">
      <div className="modal-dialog modal-dialog-centered modal-custom-width">
        <div className="modal-content modal-radius">
          <div className="modal-body">
            <div className="close-modal" onClick={onClose}>
              <img src={Images.Close} alt="Close" />
            </div>

            <div className="pt-2">
              <h5 className="popup-title">{title}</h5>
            </div>

            <div className="modal-des mt-2">
              <p>{message}</p>

              <div className="modal-img text-center">
                <img src={Images.Error} className="img-fluid" />
              </div>

              <button
                className="main-btn outline-error-btn w-full"
                onClick={onClose}
                type="button"
              >
                {t("confirm")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
